import { render, staticRenderFns } from "./RegisterClinic.vue?vue&type=template&id=08e4d2d0&"
import script from "./RegisterClinic.vue?vue&type=script&lang=js&"
export * from "./RegisterClinic.vue?vue&type=script&lang=js&"
import style0 from "./RegisterClinic.vue?vue&type=style&index=0&id=08e4d2d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports